import { render } from "./TramiteForm.vue?vue&type=template&id=4414311d&scoped=true"
import script from "./TramiteForm.vue?vue&type=script&lang=js"
export * from "./TramiteForm.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=4414311d&scoped=true&lang=css"
import "./TramiteForm.vue?vue&type=style&index=1&id=4414311d&scoped=true&lang=css"
import "./TramiteForm.vue?vue&type=style&index=2&id=4414311d&scoped=true&lang=css"
import "./TramiteForm.vue?vue&type=style&index=3&id=4414311d&scoped=true&lang=css"
import "./TramiteForm.vue?vue&type=style&index=4&id=4414311d&scoped=true&lang=css"
import "./TramiteForm.vue?vue&type=style&index=5&id=4414311d&scoped=true&lang=css"
import "./TramiteForm.vue?vue&type=style&index=6&id=4414311d&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4414311d"]])

export default __exports__